/* eslint-disable react/forbid-prop-types */
import React from 'react';
// Replace react-export-excel with xlsx and file-saver
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Row, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../utils/helpers';
// import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';
import ResizableDataTable from '../advertisment/AdvProducts/ResizableReactTableWithoutPagination';

// Remove these lines as we're replacing with xlsx
// const { ExcelFile } = ReactExport;
// const { ExcelSheet, ExcelColumn } = ExcelFile;

const DataIngestionBatchStatusTable = ({ data, tableHeaderData }) => {
    
    // Process data for Excel export (same logic as before)
    const getExcelData = () => {
        if (!data?.length) return [];
        
        return data.map((item) => {
            const updated = { ...item };
            const { impressions, clicks, orders, units,
                sales, conversion, cost, cpc, ctr,
                acos, roas} = updated;
                
            updated.impressions = setCurrencyFormat(Number(impressions).toFixed(0), false);  
            updated.clicks = setCurrencyFormat(Number(clicks).toFixed(0), false);
            updated.orders = setCurrencyFormat(Number(orders).toFixed(0), false);
            updated.units = setCurrencyFormat(Number(units).toFixed(0), false);
            updated.sales = setCurrencyFormat(Number(sales).toFixed(0), true);
            updated.conversion = setCurrencyFormat(Number(conversion).toFixed(0), true);
            updated.cost = setCurrencyFormat(Number(cost).toFixed(0), true);
            updated.cpc = setCurrencyFormat(Number(cpc).toFixed(0), true);     
            updated.ctr = `${Number(ctr).toFixed(2)} %`;
            updated.acos = `${Number(acos).toFixed(2)} %`;
            updated.roas = setCurrencyFormat(Number(roas).toFixed(2), false);      
            
            return updated;
        });
    };

    // New function to handle Excel export using xlsx
    const exportToExcel = () => {
        try {
            const excelData = getExcelData();
            
            if (!excelData.length) {
                console.warn('No data to export');
                return;
            }

            // Transform data to match table headers
            const exportData = excelData.map(item => {
                const row = {};
                tableHeaderData.forEach(column => {
                    // Use the column header as key and accessor to get the value
                    row[column.Header] = item[column.accessor] || '';
                });
                return row;
            });

            // Create workbook and worksheet
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(exportData);

            // Add the worksheet to workbook
            XLSX.utils.book_append_sheet(wb, ws, 'report');

            // Generate Excel file and save
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
            });

            saveAs(blob, `Data_Ingestion_Batch_Status_${new Date().getFullYear()}_${new Date().getMonth() + 1}_${new Date().getDate()}.xlsx`);
        } catch (error) {
            console.error('Error exporting to Excel:', error);
            // You could add a notification here if you have a notification system
        }
    };

    return (
        <Row style={{ position: 'relative' }}>
            <div className="ExcelTable" id='dvTable'>
                {/* Replace ExcelFile component with a simple button */}
                <Button 
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={exportToExcel}
                    title="Download Excel file"
                >
                    Download
                </Button>
            </div>
            <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }} data={data} />
        </Row>
    )
}

DataIngestionBatchStatusTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
};

export default DataIngestionBatchStatusTable;